import {
    memo,
    useState,
    useEffect
} from 'react'
import { useDashboard } from '@app/layouts/dashboard/Provider'
import { usePermission } from '@shared/hooks/permissions'

import List from './parts/List'
import Add from './parts/Add'
import Form from './parts/Form'
import Estimations from './parts/EstimationsDialog'
import Refresh from './parts/Refresh'
import EasyProvider from '@shared/components/EasyProvider'
import { AnimatePresence } from 'framer-motion'

export default memo(function Offices() {
    const [instance, setInstance] = useState(null)
    const [formVisibility, setFormVisibility] = useState(false)
    const [estimationsVisibility, setEstimationsVisibility] = useState(false)

    const { setTitle } = useDashboard()
    const { hasPermission } = usePermission()

    useEffect(() => {
        setTitle('المكاتب')
    }, [])

    return (
        <EasyProvider value={{
            instance,
            setInstance,
            formVisibility,
            setFormVisibility,

            estimationsVisibility,
            setEstimationsVisibility
        }}>
            <List />
            <Refresh />
            {hasPermission('add_office') && <Add />}
            <AnimatePresence>
                {formVisibility === true && <Form />}
                {estimationsVisibility === true && <Estimations />}
            </AnimatePresence>
        </EasyProvider>
    )
})
